module.exports = __webpack_public_path__ + "beautifulwebsite.svg?337f2b4fd5c25f728466e377f8e995f3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/beautifulwebsite.svg
// module id = 36
// module chunks = 0